var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"sidebar-content general-sidebar",attrs:{"fluid":""}},[(_vm.widgetList)?_c('WidgetsList',{attrs:{"widgetList":_vm.widgetList},on:{"go-to-widget":_vm.goToWidget,"go-to-hotspot":_vm.goToHotspot}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be70048c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/sidebar/general/GeneralSidebar.vue
// module id = null
// module chunks = 